import liff from '@line/liff'
import store from '@/store'
import { ENV_KEY } from '@/constants/env'

export const liffInit = liff
  .init({ liffId: store.getters['env/GET_KEY'](ENV_KEY.LIFF_ID) })
  .then(() => {
    console.log('liff.init() done')
    const url = new window.URL(window.location.href)

    const query = new window.URLSearchParams(url.searchParams)

    if (query.has('liff.state') && query.has('error')) {
      throw new Error('ACCESS DENIED')
    }
  })
  .catch((error) => {
    console.log(`liff.init() failed: ${error.code}, ${error.message}`)
    if (!store.getters['env/GET_KEY'](ENV_KEY.LIFF_ID)) {
      console.info('LIFF Starter: Please make sure that you provided `LIFF_ID` as an environmental variable.')
    }

    return Promise.reject(error)
  })
